import React from "react";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import todo from "../assets/images/todo.png";
import natours from "../assets/images/natours.png";
import unsplash from "../assets/images/unsplash.png";
import youtube from "../assets/images/youtube-clone.png";
import weatherly from "../assets/images/weatherly.png";
import omnifood from "../assets/images/omnifood.png";

const Project = () => {
  return (
    <section className="project-container" id="project">
      <h1 className="heading-1">My Projects </h1>
      <div className="project">
        <figure className="project__fig">
          <img src={youtube} alt="Youtube clone" className="project__img" />
          <div className="project__overlay"></div>
          <figcaption className="project__caption">
            <h2 className="project__sub-heading">
              A Youtube clone app, to watch and enjoy the videos.
            </h2>
            <a
              className="project__btn"
              href="https://amitsingh777.github.io/youtube-clone/"
              target="blank"
            >
              <span>Visi Website</span>
              <span className="icon">
                <ArrowForwardIosIcon />
              </span>
            </a>
          </figcaption>
        </figure>

        <figure className="project__fig">
          <img
            src={weatherly}
            alt="Weather Application"
            className="project__img"
          />
          <div className="project__overlay"></div>
          <figcaption className="project__caption">
            <h2 className="project__sub-heading">
              A weather application, that shows 5 days weather forecast.
            </h2>
            <a
              className="project__btn"
              href="https://weather-forecastify.netlify.app/"
              target="blank"
            >
              <span>Visi Website</span>
              <span className="icon">
                <ArrowForwardIosIcon />
              </span>
            </a>
          </figcaption>
        </figure>

        <figure className="project__fig">
          <img src={todo} alt="To Do Application" className="project__img" />
          <div className="project__overlay"></div>
          <figcaption className="project__caption">
            <h2 className="project__sub-heading">
              A To Do application, to schedule your whole day.
            </h2>
            <a
              className="project__btn"
              href="https://tasks-to-complete.netlify.app/"
              target="blank"
            >
              <span>Visi Website</span>
              <span className="icon">
                <ArrowForwardIosIcon />
              </span>
            </a>
          </figcaption>
        </figure>

        <figure className="project__fig">
          <img src={unsplash} alt="unsplash" className="project__img" />
          <div className="project__overlay"></div>
          <figcaption className="project__caption">
            <h2 className="project__sub-heading">
              A picture application, that shows limited numbers of pictures.
            </h2>
            <a
              className="project__btn"
              href="https://amitsingh777.github.io/Unsplash-Pictures/"
              target="blank"
            >
              <span>Visi Website</span>
              <span className="icon">
                <ArrowForwardIosIcon />
              </span>
            </a>
          </figcaption>
        </figure>

        <figure className="project__fig">
          <img src={natours} alt="Travelling site" className="project__img" />
          <div className="project__overlay"></div>
          <figcaption className="project__caption">
            <h2 className="project__sub-heading">
              A Travelling site layout, depicting my designing skills.
            </h2>
            <a
              className="project__btn"
              href="https://natourstravelfreak.netlify.app/"
              target="blank"
            >
              <span>Visi Website</span>
              <span className="icon">
                <ArrowForwardIosIcon />
              </span>
            </a>
          </figcaption>
        </figure>

        <figure className="project__fig">
          <img src={omnifood} alt="Omnifood" className="project__img" />
          <div className="project__overlay"></div>
          <figcaption className="project__caption">
            <h2 className="project__sub-heading">
              A food ordering web app layout, this application showcases my
              designing skills.
            </h2>
            <a
              className="project__btn"
              href="https://omnifoodie.netlify.app/"
              target="blank"
            >
              <span>Visi Website</span>
              <span className="icon">
                <ArrowForwardIosIcon />
              </span>
            </a>
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Project;
